const func = $target => {
    window.loader.key('datatables', function() {
        $target.DataTable({
            responsive: true,
            pageLength: 50,
            order: [[3, 'desc']]
        });
    })
};

export default func;